import { normalizeCurrency, convertAmount, type Currency } from "./currency";

const COPY = {
  es: ["Se cobrará", "equivalente aproximado"], en: ["You will be charged", "approximate equivalent"],
  fr: ["Le montant débité sera", "équivalent approximatif"], de: ["Berechnet werden", "ungefährer Gegenwert"],
  it: ["Verrà addebitato", "equivalente approssimativo"], pt: ["Será cobrado", "equivalente aproximado"],
};
export function chargeDisclosure(amount: number, source: string, target: Currency, lang: string, rates: Record<string, number>) {
  const code = normalizeCurrency(source);
  const copy = COPY[lang.slice(0, 2) as keyof typeof COPY] ?? COPY.es;
  const locale = lang.slice(0, 2) === "es" ? "es-MX" : lang.slice(0, 2) === "en" ? "en-US" : lang;
  const money = (value: number, currency: Currency) => `${currency} ${new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)}`;
  const exact = money(amount, code);
  return `${copy[0]} ${exact}${code === target ? "" : `; ${copy[1]} ${money(convertAmount(amount, code, target, rates), target)}`}`;
}